import { ApiService } from 'services';
import { history } from 'containers/App';

export const GET_ONLINE_CONFIG_REQUEST = 'GET_ONLINE_CONFIG_REQUEST';
export const GET_ONLINE_CONFIG_FAILURE = 'GET_ONLINE_CONFIG_FAILURE';
export const GET_ONLINE_CONFIG_SUCCESS = 'GET_ONLINE_CONFIG_SUCCESS';
export const CLEAR_ONLINE_CONFIG_DEFAULT_FORM = 'CLEAR_ONLINE_CONFIG_DEFAULT_FORM';
export const SESSION_TIME_OUT = 'SESSION_TIME_OUT';

function request() {
  return {
    type: GET_ONLINE_CONFIG_REQUEST,
  };
}

function receive(data) {
  return {
    type: GET_ONLINE_CONFIG_SUCCESS,
    onlineConfig: data
  };
}

function reject() {
  return {
    type: GET_ONLINE_CONFIG_FAILURE
  };
}

export function clearDefaultForm() {
  return (dispatch) => {
    dispatch({ type: CLEAR_ONLINE_CONFIG_DEFAULT_FORM });
  };
}

export function timeOutSession() {
  return (dispatch) => {
    dispatch({ type: SESSION_TIME_OUT });
  };
}

export function getOnlineConfig() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getOnlineConfig()
      .then((response) => {
        dispatch(receive(response.data.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(reject());
          if (error.message === 'Network Error') {
            history.push('/no-internet');
          }

          if (error.response.status) {
            if (error.response.status === 403) {
              history.push('/unlicensed');
            }

            if (error.response.status === 429
              || error.response.status === 502
              || error.response.status === 503) {
              history.push('/unavailable');
            }

            if (error.response.status === 500) {
              history.push('/server');
            }
          }
        }
      });
    return promise();
  };
}
